(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tccb-bullion-charts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tccb-bullion-charts')) {
    customElements.define('tccb-bullion-charts', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('change', event => {
          if (event.target.matches('[data-chart-currency]')) this.dataset.currency = event.target.value;
          else if (event.target.matches('[data-chart-period]')) this.dataset.period = event.target.value;
          else return;
          this.drawCharts();
        });
        this.drawCharts();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      drawCharts() {
        this.observer?.disconnect();
        const currency = this.dataset.currency;
        const period = this.dataset.period;
        const mount = card => {
          if (card.dataset.mounted === 'true') return;
          card.dataset.mounted = 'true';
          const ticker = card.dataset.metal + currency;
          const exchange = card.dataset.metal === 'XPT' && currency === 'CAD' ? 'FX_IDC' : 'OANDA';
          const host = card.querySelector('.tradingview-widget-container');
          const script = document.createElement('script');
          script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js';
          script.async = true;
          script.textContent = JSON.stringify({symbol: exchange + ':' + ticker, width: '100%', height: 250, locale: 'en', dateRange: period, colorTheme: 'light', isTransparent: false, autosize: true, largeChartUrl: '', chartOnly: false, noTimeScale: false, trendLineColor: '#786641', underLineColor: 'rgba(199,170,112,0.22)', underLineBottomColor: 'rgba(199,170,112,0)', utm_source: location.hostname, utm_medium: 'widget', utm_campaign: 'mini-symbol-overview'});
          script.addEventListener('error', () => {
            if (!host.isConnected) return;
            host.querySelector('.tradingview-widget-container__widget').textContent = this.dataset.unavailable;
          });
          host.appendChild(script);
        };
        if ('IntersectionObserver' in window) this.observer = new IntersectionObserver(entries => { entries.forEach(entry => { if (entry.isIntersecting) { mount(entry.target); this.observer.unobserve(entry.target); } }); }, {rootMargin: '200px'});
        this.querySelectorAll('[data-metal]').forEach(card => {
          card.dataset.mounted = 'false';
          card.querySelector('[data-currency-label]').textContent = currency;
          const exchange = card.dataset.metal === 'XPT' && currency === 'CAD' ? 'FX_IDC' : 'OANDA';
          const link = card.querySelector('[data-chart-source]');
          link.href = 'https://www.tradingview.com/symbols/' + card.dataset.metal + currency + '/?exchange=' + exchange;
          const host = card.querySelector('.tradingview-widget-container');
          const widget = document.createElement('div');
          widget.className = 'tradingview-widget-container__widget';
          const loading = document.createElement('p');
          loading.className = 'tccb-chart-loading';
          loading.textContent = this.dataset.loading;
          widget.appendChild(loading);
          host.replaceChildren(widget);
          if (this.observer) this.observer.observe(card); else mount(card);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
